import { render, staticRenderFns } from "./subsidary_add_hood.vue?vue&type=template&id=742bd071&lang=pug"
import script from "./subsidary_add_hood.vue?vue&type=script&lang=js"
export * from "./subsidary_add_hood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports